// extracted by mini-css-extract-plugin
export default {"menuList":"menuList--scU15","menuItem":"menuItem--qb2Q3"};